import { render, staticRenderFns } from "./FormatPicker.vue?vue&type=template&id=ac8ba068&scoped=true"
import script from "./FormatPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./FormatPicker.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormatPicker.vue?vue&type=style&index=0&id=ac8ba068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8ba068",
  null
  
)

export default component.exports